<template>
  <div class="main_Container">
    <section>
      <div class="container-fluid">
        <div class="section__top">
          <h2 class="section__title">
            {{ this.currentView }}
          </h2>
          <div class="section__buttons">
            <button
              class="btn add"
              data-bs-toggle="modal"
              data-bs-target="#addStudentModal"
              @click="generatePassword(8)"
            >
              <i class="fas fa-plus ms-1"></i>
              إضافة طالب جديد
            </button>

            <!-- Add Modal Start -->
            <div
              class="modal fade"
              id="addStudentModal"
              tabindex="-1"
              aria-labelledby="addStudentModalLabel"
              aria-hidden="true"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">أضافة طالب</h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      @click="this.clearData()"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <form
                      id="AddStudentForm"
                      @submit.prevent="addNewStudent($event)"
                    >
                      <div class="row">
                        <!-- Student Name -->
                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <label for="studentName">الاسم</label>
                            <input
                              type="text"
                              id="studentName"
                              class="form-control"
                              placeholder="الاسم"
                              v-model="student.name"
                              required
                            />
                          </div>
                        </div>
                        <!-- Student Phone -->
                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <label for="studentPhone">رقم الهاتف</label>
                            <input
                              type="tel"
                              id="studentPhone"
                              class="form-control"
                              placeholder="رقم الهاتف"
                              v-model="student.phone"
                              required
                            />
                          </div>
                        </div>
                        <!-- Student Password -->
                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <label for="studentPassword">كلمة المرور</label>
                            <input
                              type="text"
                              id="studentPassword"
                              class="form-control"
                              placeholder="كلمة المرور"
                              v-model="student.password"
                              required
                              maxlength="8"
                            />
                          </div>
                        </div>
                        <!-- Student Grade -->
                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <label for="studentGrade">المرحلة</label>
                            <select
                              id="studentGrade"
                              class="form-select form-control"
                              @change="selectGrade($event.target.value)"
                              v-model="student.grade_id"
                              required
                            >
                              <option selected disabled :value="0">
                                المرحلة
                              </option>
                              <option
                                :value="grade.category_id"
                                v-for="(grade, index) in this.grades"
                                :key="index"
                              >
                                {{ grade.title }}
                              </option>
                            </select>
                          </div>
                        </div>

                        <!-- Students Classes -->
                        <div class="col-12">
                          <div class="form-group">
                            <label for="studentClasses">الفصول</label>
                            <v-select
                              v-if="classes.length > 0"
                              class="form-select form-control mt-2"
                              v-model="student.fullClassesInfo"
                              multiple
                              :options="classes"
                              label="title"
                            />
                            <div v-else class="text-center">
                              <span>لا يوجد فصول حتى الان</span>
                            </div>
                          </div>
                        </div>
                        <!-- center -->
                        <div class="col-12">
                          <div class="form-group">
                            <label for="studentCenter">السنتر</label>
                            <input
                              type="text"
                              id="studentCenter"
                              class="form-control"
                              placeholder="السنتر"
                              v-model="student.center"
                            />
                          </div>
                        </div>

                        <!-- Buttons -->
                        <div class="col-12">
                          <div class="form-group text-start mt-4">
                            <button type="submit" class="btn add w-100">
                              أضافة
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <!-- Add Modal End -->

            <div class="dropdown sorting">
              <button
                class="btn add me-2 dropdown-toggle"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                type="button"
              >
                <i class="fas fa-filter ms-1"></i>
                ترتيب {{ this.currentView }}
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li class="dropdown-item" @click="sortByCreateDate">
                  ترتيب حسب التاريخ
                </li>
                <li class="dropdown-item" @click="sortByName">
                  ترتيب حسب الاسم
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="data">
          <div v-show="this.isloading" class="data__loading">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <Transition name="scale" mode="out-in">
            <div class="table__select" v-if="this.checkedStudents.length > 0">
              <div class="table__select__count">
                تم تحديد {{ this.checkedStudents.length }}
              </div>
              <div class="table__select__buttons">
                <button
                  class="btn add"
                  data-bs-toggle="modal"
                  data-bs-target="#addStudentsToClassModal"
                >
                  <i class="fas fa-plus ms-1"></i>
                  إضافة فى فصل
                </button>
                <!-- Select Modal Start -->
                <div
                  class="modal fade"
                  id="addStudentsToClassModal"
                  tabindex="-1"
                  aria-labelledby="addStudentsToClassModalLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title">أضافة الطلاب فى فصل</h5>
                        <button
                          type="button"
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div class="modal-body">
                        <form @submit.prevent="addStudentsList">
                          <div class="row">
                            <!-- Students Classes -->
                            <div class="col-12">
                              <div class="form-group">
                                <label for="studentClasses">الفصول</label>
                                <v-select
                                  v-if="classes.length > 0"
                                  class="form-select form-control mt-2"
                                  v-model="updateStudentObj.fullClassesInfo"
                                  multiple
                                  :options="classes"
                                  label="title"
                                />
                                <div v-else class="text-center">
                                  <span>لا يوجد فصول حتى الان</span>
                                </div>
                              </div>
                            </div>

                            <!-- Buttons -->
                            <div class="col-12">
                              <div class="form-group text-start mt-4">
                                <button
                                  type="submit"
                                  data-bs-dismiss="modal"
                                  class="btn w-100 add"
                                >
                                  أضافة
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Select Modal Start -->
                <button class="btn print" @click="printStudentsList">
                  <i class="fas fa-print ms-1"></i>
                  طباعة
                </button>
                <button class="btn delete" @click="deleteStudentsList()">
                  <i class="fas fa-trash-alt ms-2"></i>
                  حذف
                </button>
              </div>
            </div>
          </Transition>
          <div v-show="!this.isloading" class="table-responsive">
            <form @submit.prevent="">
              <div class="searching">
                <div class="form-group">
                  <input
                    type="search"
                    @input="getDocBySeacrh($event)"
                    class="form-control mt-2"
                    placeholder="هل تبحث عن ...."
                    required
                  />
                </div>
              </div>
            </form>
            <table
              v-show="this.students.length > 0"
              class="table table-striped"
            >
              <thead>
                <tr>
                  <th class="text-center" style="width: 5%" scope="col">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="allSelected"
                      @change="selectAll"
                    />
                  </th>
                  <th style="width: 5%" scope="col">الرقم</th>
                  <th scope="col">اسم طالب</th>
                  <th scope="col">رقم الطالب</th>
                  <th scope="col">الصف الدراسي</th>
                  <th scope="col">الفصول</th>
                  <th style="width: 40%" scope="col">التحكم</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(student, index) in this.students" :key="index">
                  <th class="text-center" scope="row">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="flexCheckDefault"
                      v-model="checkedStudents"
                      @change="updateCheckall()"
                      :value="student"
                    />
                  </th>
                  <th class="text-center" scope="row">{{ index + 1 }}</th>
                  <td>{{ student.name }}</td>
                  <td>{{ student.phone }}</td>
                  <td>{{ student.grade.title }}</td>
                  <td>
                    <div>
                      <ul class="mb-0 pe-0">
                        <li
                          v-for="(className, index) in student.fullClassesInfo"
                          :key="index"
                        >
                          - {{ className.title }}
                        </li>
                      </ul>
                    </div>
                  </td>

                  <td>
                    <div class="control">
                      <router-link
                        :to="{
                          name: 'studentContent',
                          params: { index: student.student_id },
                        }"
                        class="btn add"
                        v-if="hasPermission('codes')"
                      >
                        <i class="fas fa-plus ms-1"></i>
                        المحتوى
                      </router-link>
                      <button
                        class="btn print me-2"
                        @click="printStudent(student)"
                      >
                        <i class="fas fa-print ms-1"></i>
                        طباعة
                      </button>

                      <button
                        class="btn me-2 edit"
                        data-bs-toggle="modal"
                        data-bs-target="#EditStudentModal"
                        @click="this.getSelectStudent(student)"
                      >
                        <i class="fas fa-edit ms-1"></i>
                        تعديل
                      </button>
                      <div
                        class="modal fade"
                        tabindex="-1"
                        id="EditStudentModal"
                        aria-labelledby="EditStudentModalLabel"
                        data-bs-backdrop="static"
                        aria-hidden="true"
                      >
                        <div class="modal-dialog modal-dialog-centered">
                          <div class="modal-content">
                            <div class="modal-body text-end">
                              <div class="text-start">
                                <button
                                  type="button"
                                  class="btn-close"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                ></button>
                              </div>
                              <form @submit.prevent="updateSelectStudent">
                                <div class="row">
                                  <!-- Student Name -->
                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="studentName">الاسم</label>
                                      <input
                                        type="text"
                                        id="studentName"
                                        class="form-control"
                                        placeholder="الاسم"
                                        v-model="updateStudentObj.name"
                                        required
                                      />
                                    </div>
                                  </div>
                                  <!-- Student Phone -->
                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="studentPhone"
                                        >رقم الهاتف</label
                                      >
                                      <input
                                        type="tel"
                                        id="studentPhone"
                                        class="form-control"
                                        placeholder="رقم الهاتف"
                                        v-model="updateStudentObj.phone"
                                        required
                                      />
                                    </div>
                                  </div>
                                  <!-- Student Password -->
                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="studentPassword"
                                        >كلمة المرور</label
                                      >
                                      <input
                                        type="text"
                                        id="studentPassword"
                                        class="form-control"
                                        placeholder="كلمة المرور"
                                        v-model="updateStudentObj.password"
                                        required
                                        maxlength="8"
                                      />
                                    </div>
                                  </div>
                                  <!-- Student Grade -->
                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="studentGrade2">المرحلة</label>
                                      <select
                                        id="studentGrade2"
                                        class="form-select form-control"
                                        @change="
                                          editSelectGrade($event.target.value)
                                        "
                                        v-model="updateStudentObj.grade_id"
                                        required
                                      >
                                        <option selected disabled :value="0">
                                          المرحلة
                                        </option>
                                        <option
                                          :value="grade.category_id"
                                          v-for="(grade, index) in this.grades"
                                          :key="index"
                                        >
                                          {{ grade.title }}
                                        </option>
                                      </select>
                                    </div>
                                  </div>

                                  <!-- Students Classes -->
                                  <div class="col-12">
                                    <div class="form-group">
                                      <label for="studentClasses">الفصول</label>
                                      <v-select
                                        v-if="classes.length > 0"
                                        class="form-select form-control mt-2"
                                        v-model="
                                          updateStudentObj.fullClassesInfo
                                        "
                                        multiple
                                        :options="classes"
                                        label="title"
                                      />
                                      <div v-else class="text-center">
                                        <span>لا يوجد فصول حتى الان</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-12">
                                    <div class="form-group">
                                      <label for="studentCenterUpdate"
                                        >السنتر</label
                                      >
                                      <input
                                        type="text"
                                        id="studentCenterUpdate"
                                        class="form-control"
                                        placeholder="السنتر"
                                        v-model="updateStudentObj.center"
                                      />
                                    </div>
                                  </div>
                                  <!-- Buttons -->
                                  <div class="col-12">
                                    <div class="form-group text-start mt-4">
                                      <button
                                        data-bs-dismiss="modal"
                                        class="btn w-100 edit"
                                      >
                                        تعديل
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button
                        class="btn me-2 delete"
                        @click="deleteSelectedStudent(student)"
                      >
                        <i class="fas fa-trash-alt ms-1"></i>
                        حذف
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <nav
              class="pagination"
              v-show="this.isShowButton"
              aria-label="Page navigation"
            >
              <button
                class="btn add"
                @click="this.getNextSelectedData"
                v-if="!this.loadingMore"
              >
                تحميل المزيد
              </button>
              <div v-else>
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </nav>
            <div
              v-show="
                (!this.isloading && !this.students) || this.students.length == 0
              "
              class="empty-state"
            >
              <div class="empty-state__icon">
                <i class="fas fa-folder"></i>
              </div>
              <h3 class="empty-state__text">لا يوجد طلاب حتى الآن</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Print Student -->
    <section>
      <vue3-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        filename="Student_Report"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="800px"
        @progress="onProgress($event)"
        @hasStartedGeneration="hasStartedGeneration()"
        @hasGenerated="hasGenerated($event)"
        ref="html2Pdf"
      >
        <template v-slot:pdf-content>
          <div class="pdf once">
            <img class="w-100 pdf__background" src="@/assets/student_pdf.jpeg" />
            <div class="pdf__info">
              <div class="pdf__info__name">
                {{ this.studentPrint.name }}
              </div>
              <div class="pdf__info__grade">
                {{ (this.studentPrint.grade || {}).title }}
              </div>
              <div class="pdf__info__password">
                {{ this.studentPrint.password }}
              </div>
              <div class="pdf__info__phone">
                {{ this.studentPrint.phone }}
              </div>
              <div class="pdf__info__center">
                {{ this.studentPrint.center }}
              </div>
            </div>
          </div>
        </template>
      </vue3-html2pdf>
    </section>
    <!-- Print Multi Students -->
    <section>
      <vue3-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        filename="Student_Report"
        :pdf-quality="1"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="800px"
        @progress="onProgress($event)"
        @hasStartedGeneration="hasStartedGeneration()"
        @hasGenerated="hasGenerated($event)"
        ref="multiStudents"
      >
        <template v-slot:pdf-content>
          <div
            class="pdf multi"
            v-for="(student, index) in this.checkedStudents"
            :key="index"
          >
            <img class="w-100 pdf__background" src="@/assets/student_pdf.jpeg" />
            <div class="pdf__info">
              <div class="pdf__info__name">
                {{ student.name }}
              </div>
              <div class="pdf__info__grade">
                {{ (student.grade || {}).title }}
              </div>
              <div class="pdf__info__password">
                {{ student.password }}
              </div>
              <div class="pdf__info__phone">
                {{ student.phone }}
              </div>
              <div class="pdf__info__center">
                {{ student.center }}
              </div>
            </div>
          </div>
        </template>
      </vue3-html2pdf>
    </section>
  </div>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from "vuex";
// Swal
import Swal from "sweetalert2";
// Print PDF
import Vue3Html2pdf from "vue3-html2pdf";

export default {
  data() {
    return {
      // Loading
      isloading: false,
      // Get Categories has Main
      grades: [],
      // All Classes
      classes: [],
      // Current Page Name
      currentView: "الطلاب",
      students: [],
      // update Student
      updateStudentObj: {},
      // Print Student
      studentPrint: {
        name: "",
        password: "",
        phone: "",
        grade: {
          title: "",
        },
      },
      // Student Data
      student: {
        name: null,
        password: null,
        phone: null,
        grade_id: null,
        grade: {},
        classes: [],
        fullClassesInfo: [],
        center: "",
      },
      classesBefore: [],
      studentBeforeEdit: {},
      // Select
      allSelected: false,
      checkedStudents: [],
      // Pagination
      loadingMore: false,
      isShowButton: true,

      // Search
      searchResult: [],
    };
  },
  components: {
    Vue3Html2pdf,
  },
  methods: {
    ...mapActions("studentsModule", [
      // "fetchStudents",
      "addStudent",
      "getStudentById",
      "updateStudent",
      "deleteStudent",
      "deleteStudents",
      "addClassesToStudents",
      // Pagination
      "getFirstData",
      "getNextData",
      "changeSorting",

      // Search
      "searchData",
    ]),
    ...mapActions("classesModule", [
      "fetchClasses",
      "addStudentToClass",
      "removeStudentFromClass",
      "increaseCount",
      "decreaseCount",
      "addStudentsToClass",
    ]),

    // Pagination
    getNextSelectedData() {
      this.getNextData();
    },
    getPrevSelectedData() {
      this.getPrevData();
    },

    //--------------------------------------------
    // Sorting
    sortByCreateDate() {
      this.changeSorting("created_date");
      this.getFirstData();
    },
    sortByName() {
      this.changeSorting("name");
      this.getFirstData();
    },
    //-------------------------------------
    // Search
    getDocBySeacrh(e) {
      if (e.target.value == "") {
        this.students = this.getStudents;
      } else {
        setTimeout(() => {
          this.searchData(e.target.value);
          this.students = this.searchResult;
        }, 800);
      }
    },
    //-------------------------------------

    // Grt All Students
    async getAllStudent() {
      if (this.isFirstLoad) this.students = await this.fetchStudents();
    },

    //-------------------------------------
    // Select
    async selectAll() {
      this.checkedStudents = [];
      if (this.allSelected) {
        const selected = this.students.map((student) => student);
        this.checkedStudents.push(...selected);
      } else {
        this.selected = [];
        this.checkedStudents = [];
      }
    },
    updateCheckall() {
      if (this.students.length == this.checkedStudents.length) {
        this.allSelected = true;
      } else {
        this.allSelected = false;
      }
    },
    //---------------------------------------------------
    // Functions On Select Students
    async deleteStudentsList() {
      Swal.fire({
        text: "هل أنت متأكد من حذف هولاء الطلاب؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم حذف الاكواد بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.deleteStudents(this.checkedStudents);
          this.removeStudentFromClass(this.checkedStudents);
          this.decreaseCount(this.checkedStudents.classes);
          this.checkedStudents = [];
        }
      });
    },

    async addStudentsList() {
      this.updateStudentObj.fullClassesInfo.forEach((classID) =>
        this.classesBefore.push(classID.class_id)
      );
      let StudentsIDs = [];
      this.checkedStudents.forEach((studentID) =>
        StudentsIDs.push(studentID.student_id)
      );
      let payload = {
        students: this.checkedStudents,
        classes: this.classesBefore,
        fullClassesInfo: this.updateStudentObj.fullClassesInfo,
      };
      this.addClassesToStudents(payload);
      this.increaseCount(this.classesBefore);

      let classPayload = {
        classes: this.classesBefore,
        students: StudentsIDs,
      };
      this.addStudentsToClass(classPayload);

      this.clearAndShowSuccess("تم اضافة الطلاب بالفصول بنجاح");
    },

    //-----------------------------------------------------
    // Default Buttons in Table
    // Add New Student
    async addNewStudent(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");

      this.getClassesIds(this.student.fullClassesInfo);
      this.increaseCount(this.student.classes);
      let studentCreated = await this.addStudent(this.student);
      this.addStudentToClass(studentCreated);
      closeButton.click();

      this.clearAndShowSuccess("تم الإضافة بنجاح");
      document.getElementById("studentGrade").value = 0;
    },

    // Delete Student
    deleteSelectedStudent(student) {
      Swal.fire({
        text: "هل أنت متأكد من حذف هذا الطالب؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم الحذف بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.removeStudentFromClass(student);
          this.deleteStudent(student.student_id);
          this.decreaseCount(student.classes);
        }
      });
    },

    // Get Student By Id
    async getSelectStudent(student) {
      await this.getStudentById(student.student_id);
      this.studentBeforeEdit = student;

      this.updateStudentObj = {
        ...this.getUpdateStudent,
        grade_id: this.getUpdateStudent?.grade_id
          ? this.getUpdateStudent?.grade_id
          : this.getUpdateStudent?.grade?.id ||
            this.getUpdateStudent?.grade?.category_id,
      };
      this.classesBefore = this.updateStudentObj.classes;
    },

    // Update Student
    updateSelectStudent(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");
      this.getEditClassesIds(this.updateStudentObj.fullClassesInfo);
      if (this.classesBefore != this.updateStudentObj.classes) {
        // before
        this.removeStudentFromClass(this.studentBeforeEdit);
        this.decreaseCount(this.studentBeforeEdit.classes);
        // After
        this.addStudentToClass(this.updateStudentObj);
        this.increaseCount(this.updateStudentObj.classes);
      }
      this.updateStudent(this.updateStudentObj);
      closeButton.click();

      this.clearAndShowSuccess("تم التعديل بنجاح");
    },

    // Print Student
    printStudent(student) {
      this.studentPrint = student;
      this.$refs.html2Pdf.generatePdf();
    },
    // Print Student
    async printStudentsList() {
      await this.$refs.multiStudents.generatePdf();
      this.checkedStudents = [];
    },
    // Code Download PDF
    onProgress(event) {
      console.log(`Processed: ${event} / 100`);
    },
    hasGenerated() {
      alert("PDF generated successfully!");
    },
    //-----------------------------------------------------
    // Get Classes Ids Only
    //-----On Add
    getClassesIds(classes) {
      this.student.classes = [];
      classes.forEach((classItem) => {
        this.student.classes.push(classItem.class_id);
      });
    },

    selectGrade(grade) {
      let item = this.grades.find((item) => item.category_id == grade);
      this.student.grade_id = item.category_id;
      this.student.grade = item;
    },
    //-----On Edit
    getEditClassesIds(classes) {
      this.updateStudentObj.classes = [];
      classes.forEach((classItem) => {
        this.updateStudentObj.classes.push(classItem.class_id);
      });
    },
    editSelectGrade(grade) {
      let item = this.grades.find((item) => item.category_id == grade);
      this.updateStudentObj.grade_id = item.category_id;
      this.updateStudentObj.grade.title = item;
    },
    //-----------------------------------------------------
    // Clear Input and Messages me Success
    clearAndShowSuccess(message) {
      this.successAdd(message);
      this.clearData();
    },
    // Toast Seccuss Message
    successAdd(message) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: message,
      });
    },
    // Clear Data
    clearData() {
      document.getElementById("studentGrade").value = 0;

      this.student = {
        name: "",
        password: "",
        phone: "",
        grade: {
          id: "",
          title: "default",
        },
        classes: [],
        fullClassesInfo: [],
      };
      this.classesBefore = [];
      this.checkedStudents = [];
      this.updateStudentObj = {};
    },
    // Generate Random Password
    generatePassword(length) {
      const characters = "0123456789";
      let result = "";
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      this.student.password = result;
    },
  },
  async created() {
    // if (this.isFirstLoad) await this.fetchStudents();
    if (this.isFirstLoad) await this.getFirstData();

    // get Main Categories
    this.grades = this.getCategories.filter(
      (item) => item.main_category === true && item.show_on_register === true
    );
  },
  computed: {
    ...mapGetters("categoriesModule", ["getCategories"]),
    ...mapGetters("classesModule", ["getClasses"]),

    ...mapGetters("studentsModule", [
      "getStudents",
      "getUpdateStudent",
      "isLoading",
      "isFirstLoad",
      // Pagination
      "isLoadingMore",
      "isShowLoadingButton",
      // Search
      "getSearchResult",
    ]),
  },
  mounted() {
    this.students = this.getStudents;
    this.categories = this.getCategories;
    this.classes = this.getClasses;
    this.isloading = this.isLoading;
    this.firstLoad = this.isFirstLoad;
    // Pagination
    this.isShowButton = this.isShowLoadingButton;
    this.loadingMore = this.isLoadingMore;

    // Search
    this.searchResult = this.getSearchResult;
    document.getElementById("studentGrade").value = 0;
  },
  watch: {
    getStudents() {
      this.students = this.getStudents;
    },
    getCategories() {
      this.categories = this.getCategories;
    },
    getClasses() {
      this.classes = this.getClasses;
    },
    isLoading() {
      this.isloading = this.isLoading;
    },
    isFirstLoad() {
      this.firstLoad = this.isFirstLoad;
    },
    // Pagination
    isLoadingMore() {
      this.loadingMore = this.isLoadingMore;
    },
    isShowLoadingButton() {
      this.isShowButton = this.isShowLoadingButton;
    },
    // Search
    getSearchResult() {
      this.searchResult = this.getSearchResult;
    },
  },
};
</script>

<style></style>
